import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import { useFormContext } from 'react-hook-form'

import { EnrollmentChildInput } from '../../../../lib/types/models/enrollment/enrollment-child-input'
import { FormControl, FormField, FormItem } from '../../../elements/forms/form'
import ControlledInput from '../../../elements/inputs/controlled-input'

const ClientEnrollmentChildFamilyLetter = () => {
  const form = useFormContext<EnrollmentChildInput>()

  return (
    <InnerBox className="p-4 rounded-xl flex flex-col gap-2">
      <Typography variant="text" color={tailwindColors.grey.DEFAULT}>
        Lettre du participant à sa famille hôtesse
      </Typography>
      <Typography variant="label-medium" color={tailwindColors.grey.lighter}>
        Le jeune participant doit écrire une lettre à l'attention de sa future famille-hôtesse,
        dans la langue du pays de séjour (d'au moins 600 caractères) où il se présente, parle de
        ses goûts, de ses hobbies et de sa famille. Cette lettre doit refléter l'enthousiasme et la
        personnalité du jeune et doit être écrite avec beaucoup de gentillesse. Votre enfant doit
        notamment signaler s'il a des frères et sœurs, préciser leurs âges, les intérêts et
        activités qu'ils partagent. Il doit également décrire les hobbies auxquels il pourrait
        s'adonner avec sa famille-hôtesse afin de l'inviter, dès lecture de sa lettre, à pratiquer
        en commun les mêmes activités. La lettre doit refléter le niveau du jeune (elle ne doit pas
        être écrite par les parents ni par un outil de traduction ou une IA).
      </Typography>

      <FormField
        control={form.control}
        name="childHostFamilyLetter"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <ControlledInput
                {...field}
                type="textarea"
                placeholder="Écrivez votre lettre ici..."
                rows={20}
                min={600}
                minLength={600}
              />
            </FormControl>
          </FormItem>
        )}
      />
    </InnerBox>
  )
}

export default ClientEnrollmentChildFamilyLetter
